export default "__VITE_ASSET__015953ca__"